{
  "name": "Elsie Hamilton Subharmonic Modes",
  "description": "12-tone 13-Limit Rational Intonation (JI) scale including the 8 note modes used by JI pioneer Elsie Hamilton (1880-1965). Inspired by Kathleen Schlesinger's research into ancient instruments and modes (The Greek Aulos), Hamilton worked with subharmonic modes which emerge naturally when instruments have holes or frets placed at equal distances. The intervals fall downward from E, A, F, D, B, following the intervals of the harmonic partials taken downward.",
  "scale": [
    "12/11",
    "8/7",
    "6/5",
    "5/4",
    "4/3",
    "45/32",
    "3/2",
    "8/5",
    "12/7",
    "24/13",
    "15/8",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12-HamiltonModes",
  "built_in_group": "Marc Sabat NYKY Ensemble",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": ["B", "C", "C", "D", "*nD", "E", "*nE", "F", "G", "G", "A", "*nA"],
  "note_colors": [
    "#d0d0d7",
    "#ffffff",
    "#ffffff",
    "#d0d0d7",
    "#ffffff",
    "#d0d0d7",
    "#ffffff",
    "#ffffff",
    "#d0d0d7",
    "#ffffff",
    "#d0d0d7",
    "#ffffff"
  ],
  "equivSteps": 12,
  "fundamental": 441,
  "reference_degree": 11,
  "center_degree": 6,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 26,
  "lumatone_anchor_channel": 3
}
